import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";

const GoogleSuccess = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const {
        setAuthToken,
        loginCustomerToOneSignal
    } = useContext(AppContext);

    useEffect(() => {

        const handleGoogleLogin = async () => {

            const params = new URLSearchParams(location.search);

            const token = params.get("token");
            const role = params.get("role");
            const customerId = params.get("customer_id");
            localStorage.setItem(
    "customer",
    JSON.stringify({
        id: customerId
    })
);

            console.log("Google Login Token:", token);
            console.log("Google Login Role:", role);
            console.log("Google Customer ID:", customerId);

            if (!token) {
                return;
            }

            // ================= AUTH TOKEN =================

            localStorage.setItem("authToken", token);
            setAuthToken(token);


            // ================= CUSTOMER =================

            if (role === "customer") {

                localStorage.setItem(
                    "customerLoggedIn",
                    "true"
                );

                // ================= ONESIGNAL =================

                if (customerId) {

                    console.log(
                        "Logging Google customer into OneSignal:",
                        customerId
                    );

                    const success =
                        await loginCustomerToOneSignal(
                            customerId
                        );

                    console.log(
                        "Google Customer OneSignal Login:",
                        success
                    );

                } else {

                    console.error(
                        "Google Customer ID missing!"
                    );

                }

                // Dashboard par OneSignal login ke BAAD jao
                navigate("/customer-dashboard");

            }


            // ================= WORKER =================

            if (role === "worker") {

                localStorage.setItem(
                    "workerLoggedIn",
                    "true"
                );

                navigate("/worker-dashboard");

            }

        };

        handleGoogleLogin();

    }, [location.search, navigate, setAuthToken, loginCustomerToOneSignal]);


    return (
        <div>
            Logging in...
        </div>
    );
};

export default GoogleSuccess;